import { ReactElement } from "react";
import { Text, TextProps } from "@mantine/core";

export default function ErrorMessage({
  children,
  ...textProps
}: TextProps): ReactElement {
  return (
    <Text c="red.2" fz="sm" {...textProps}>
      {children}
    </Text>
  );
}
